// ESLint does not allow the use of ==, but the value of the input is a string, so it is necessary to use ==.
/* eslint-disable eqeqeq */
import { IS_SHOW, SEMI_MONTHLY_TAX_DEDUCTION_OPTIONS, PAYMENT_COUNT_OPTIONS } from 'src/constants/Options';
import _ from 'lodash';

const getValue = (label, props) => props.map(e => ({ label: e[label], value: e.value, numberValue: e.numberValue }));

export function changeRadioLabel(language, props) {
  const getLabel = () => {
    if (language === 'th') return 'labelThai';
    else if (language === 'en') return 'labelEng';
    return 'labelJa';
  };
  const payrollTypes = getValue(getLabel(), props.payrollTypes);
  const paymentMonthTypes = getValue(getLabel(), props.paymentMonthTypes);
  const applicableSsoRateMonth = getValue(getLabel(), props.applicableSsoRateMonth);
  const displayMonthNameTypes = getValue(getLabel(), props.displayMonthNameTypes);

  return { payrollTypes, paymentMonthTypes, applicableSsoRateMonth, displayMonthNameTypes };
}

export function getRadioLabel(data, state) {
  const {
    payrollType,
    paymentMonthType,
    applicableSsoRateMonth,
    displayMonthNameType,
    isShowAttendance,
    isShowProvidentFund,
    timingOfTaxDeduction,
    paymentCount,
    ...other
  } = data;

  const payrollTypeLabel = state.payrollTypes.find(e => e.value === payrollType)?.label;
  const paymentMonthTypeLabel = state.paymentMonthTypes.find(e => e.value === paymentMonthType)?.label;
  const applicableSsoRateMonthLabel = state.applicableSsoRateMonth.find(e => e.value === applicableSsoRateMonth)?.label;
  const displayMonthNameTypeLabel = state.displayMonthNameTypes.find(e => e.value === displayMonthNameType)?.label;

  const isShowAttendanceLabel = IS_SHOW.find(e => e.value == isShowAttendance)?.label;
  const isShowProvidentFundLabel = IS_SHOW.find(e => e.value == isShowProvidentFund)?.label;
  const paymentCountLabel = PAYMENT_COUNT_OPTIONS.find(item => item.value === paymentCount)?.label;

  const timingOfTaxDeductionLabel = SEMI_MONTHLY_TAX_DEDUCTION_OPTIONS.find(e => e.value == timingOfTaxDeduction)?.label;
  return {
    payrollType: payrollTypeLabel,
    paymentMonthType: paymentMonthTypeLabel,
    applicableSsoRateMonth: applicableSsoRateMonthLabel,
    displayMonthNameType: displayMonthNameTypeLabel,
    isShowAttendance: isShowAttendanceLabel,
    isShowProvidentFund: isShowProvidentFundLabel,
    timingOfTaxDeduction: timingOfTaxDeductionLabel,
    paymentCount: paymentCountLabel,
    ...other
  };
}

export function validateFormInput(form, t) {
  const errorArray = [];
  const checkUndefinedInput = (input, label) => {
    if (_.isBoolean(input)) return;
    const convertInputToString = input ? input.toString() : '';
    if (!input || convertInputToString.replaceAll(' ', '').length === 0) {
      errorArray.push(label);
    }
  };

  const fields = [
    { field: 'name', label: t('features.EmployeePays.components.DownloadColumnDetail.salary_rules_group_name') },
    { field: 'payrollType', label: t('features.Employees.components.PayrollRulenInfo.form_of_salary') },
    {
      field: 'prescribedWorkingHoursPerDay',
      label: t('features.Employees.components.PayrollRulenInfo.designated_working_hours_in_one_day')
    },
    {
      field: 'avgRegularWorkingDaysPerMonth',
      label: t('features.Employees.components.PayrollRulenInfo.average_designated_working_days_in_one_month')
    },
    {
      field: 'avgRegularWorkingHoursPerMonth',
      label: t('features.Employees.components.PayrollRulenInfo.average_designated_working_hours_in_one_month')
    },
    { field: 'closingDay', label: t('features.Employees.components.PayrollRulenInfo.cutoff_date') },
    { field: 'paymentDay', label: t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.payment_date_day') },
    {
      field: 'applicableSsoRateMonth',
      label: t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.month_of_the_applicable_sso_calculation_rate')
    },
    {
      field: 'displayMonthNameType',
      label: t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.Month_shown_in_payslip')
    },
    {
      field: 'isShowAttendance',
      label: t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.is_show_attendance')
    },
    {
      field: 'isShowProvidentFund',
      label: t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.is_show_provident_fund')
    },
    {
      field: 'paymentMonthType',
      label:
        // @TODO: Temporarily hide twice monthly payment feature, will be developed later
        // https://donuts-vn.atlassian.net/browse/JBC-92
        // form.paymentCount === 'twice'
        //   ? t('features.PayrolRulesGroups.components.PaymentTermSetting.payment_term')
        //   :
        t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.payment_date_month')
    }
  ];

  // @TODO: Temporarily hide twice monthly payment feature, will be developed later
  // https://donuts-vn.atlassian.net/browse/JBC-92
  // if (form.paymentCount === 'twice') {
  //   fields.push(
  //     {
  //       field: 'closingDaySecondHalf',
  //       label: t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.second_half_cut_off_date')
  //     },
  //     {
  //       field: 'paymentDaySecondHalf',
  //       label: t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.second_half_payment_date')
  //     },
  //     {
  //       field: 'timingOfTaxDeduction',
  //       label: t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.timing_of_tax_deduction')
  //     },
  //     {
  //       field: 'paymentCount',
  //       label: t('features.Employees.components.PayrollRulenInfo.payment_count')
  //     }
  //   );
  // }

  fields.forEach(item => {
    checkUndefinedInput(form[item.field], item.label);
  });

  return errorArray;
}
